<div
  class="container"
  *ngLet="{
    itemData: itemData$ | async,
    itemFields: itemFields$ | async
  } as async">
  <button class="btn-empty close" (click)="close()">
    <svg [icon]="icons.Close" class="dark-gray-color svg24" />
  </button>

  @if (loading) {
    <app-loader></app-loader>
  } @else {
    <div class="modal-title">
      {{title}}
    </div>
    <div class="flex-block">
      <div class="left-col">
        <div class="link-block">
          <div
            *ngFor="let link of arr"
            class="link"
            [class.active]="selectModel.isSelected(+link.global_id)"
            (click)="setData(+link.global_id, link.value)"
          >{{link.value}}</div>
        </div>
      </div>

      @if (redraw) {
        <app-loader></app-loader>
      } @else {
        <app-catalog-item-card-info2
          [headTitle]="subTitle"
          [hideTitle]="true"
          [showAllFields]="false"
          [itemFields]="async.itemFields"
          [itemData]="async.itemData"
        ></app-catalog-item-card-info2>
      }
    </div>
  }
</div>
